import { Injectable } from '@angular/core';
import { CashBalanceChartGroupType } from "../models/cash-balance-group-type.model"
import { CashBalanceFieldNames, CashBalanceFieldLabels } from "../cash-balance-field-identifiers"

@Injectable()
export class CashBalanceGroupTypeProvider {

  constructor() { }

  getChartGroupTypes(): Array<CashBalanceChartGroupType> {
    const groupTypes: Array<CashBalanceChartGroupType> = [];
    
    groupTypes.push(
      {
        Id: 0,
        GroupByField1: CashBalanceFieldNames.SubLedgerField,
        GroupByField2: CashBalanceFieldNames.TypeField,        
        Label: CashBalanceFieldLabels.SubLedgerField + ' to ' + CashBalanceFieldLabels.TypeField
      } as CashBalanceChartGroupType
    );
    groupTypes.push(
      {
        Id: 1,
        GroupByField1: CashBalanceFieldNames.TypeField,
        GroupByField2: CashBalanceFieldNames.SubLedgerField,
        Label: CashBalanceFieldLabels.TypeField + ' to ' + CashBalanceFieldLabels.SubLedgerField
      } as CashBalanceChartGroupType
    );
    
    groupTypes.push(
      {
        Id: 2,
        GroupByField1: CashBalanceFieldNames.PropertyField,
        GroupByField2: CashBalanceFieldNames.SubLedgerField,
        Label: CashBalanceFieldLabels.PropertyField + ' to ' + CashBalanceFieldLabels.SubLedgerField
      } as CashBalanceChartGroupType
    );

    groupTypes.push(
      {
        Id: 3,
        GroupByField1: CashBalanceFieldNames.PropertyField,
        GroupByField2: CashBalanceFieldNames.TypeField,
        Label: CashBalanceFieldLabels.PropertyField + ' to ' + CashBalanceFieldLabels.TypeField
      } as CashBalanceChartGroupType
    );

    groupTypes.push(
      {
        Id: 4,
        GroupByField1: CashBalanceFieldNames.SubLedgerField,
        GroupByField2: CashBalanceFieldNames.PropertyField,
        Label: CashBalanceFieldLabels.SubLedgerField + ' to ' + CashBalanceFieldLabels.PropertyField
      } as CashBalanceChartGroupType
    );
    groupTypes.push(
      {
        Id: 5,
        GroupByField1: CashBalanceFieldNames.TypeField,
        GroupByField2: CashBalanceFieldNames.PropertyField,
        Label: CashBalanceFieldLabels.TypeField + ' to ' + CashBalanceFieldLabels.PropertyField
      } as CashBalanceChartGroupType
    );
    

    return groupTypes;
  }

}
